// src/icons/ChevronRight.tsx
import { jsx } from "@emotion/react/jsx-runtime";
function ChevronRight() {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      width: "100%",
      viewBox: "0 0 9 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M1.5 1.33333L7.57742 7.41075C7.90283 7.73617 7.90283 8.26383 7.57742 8.58925L1.5 14.6667",
          stroke: "currentColor",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    }
  );
}

export {
  ChevronRight
};
